import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/css/App.css';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import TaxInfo from 'views/auth/taxInfo';
import { ChakraProvider } from '@chakra-ui/react';
import theme from 'theme/theme';

// Disable console logging in production (non-localhost)
if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.info = () => {};
  console.debug = () => {};
}

// Tax Info Portal - Restricted Deployment
// This build is configured to ONLY allow access to /auth/tax-info
// All other routes are disabled and redirect to tax-info page
ReactDOM.render(
  <ChakraProvider theme={theme}>
    <React.StrictMode>
      <HashRouter>
        <Switch>
          <Route exact path="/auth/tax-info" component={TaxInfo} />
          <Redirect from="*" to="/auth/tax-info" />
        </Switch>
      </HashRouter>
    </React.StrictMode>
  </ChakraProvider>,
  document.getElementById('root')
);